import {useScroll, useTransform, motion} from 'framer-motion';
import {useEffect, useRef} from 'react';

export default function CoreValueStickySection() {

  const containerRef = useRef(null);

  const { scrollYProgress } = useScroll({ target: containerRef, offset: ["start start", "end end"] })

  const textY = [
    null,
    useTransform(scrollYProgress, [0.0, 0.2], [180, 0]),
    useTransform(scrollYProgress, [0.2, 0.4], [180, 0]),
    useTransform(scrollYProgress, [0.4, 0.6], [180, 0]),
    useTransform(scrollYProgress, [0.6, 0.8], [180, 0]),
  ];

  const textOpacity = [
    useTransform(scrollYProgress, [0.10, 0.15], [1, 0]),
    useTransform(scrollYProgress, [0.30, 0.35], [1, 0]),
    useTransform(scrollYProgress, [0.50, 0.55], [1, 0]),
    useTransform(scrollYProgress, [0.70, 0.75], [1, 0]),
    null
  ];

  const imgScale = useTransform(scrollYProgress, [0, 1], [1, 2]);
  const imgOpacity = useTransform(scrollYProgress, [0, 1], [0, 0.6]);

  return (
    <section
      ref={containerRef}
      data-bg-type="colorful"
      className="relative w-full h-[400vh] text-center text-white text-heading1 lg:text-display2 leading-normal">
      <div
        className="sticky top-0 w-full h-screen overflow-hidden"
      >
        <motion.video
          style={{scale: imgScale}}
          autoPlay muted loop playsInline
          className="absolute inset-0 w-full h-screen object-cover object-right-bottom "
        >
          <source type='video/mp4' src={`${process.env.REACT_APP_STATIC_URL}/images/About/Section1_Background.mp4`}/>
        </motion.video>

        <motion.div
          className="absolute inset-0 w-full h-screen bg-black z-[1] transition-all ease-linear"
          style={{opacity: imgOpacity}}
        />

        <div className="absolute inset-0 w-full h-screen flex items-center justify-center z-[2]">
          <div className="overflow-hidden">
            <motion.div
              className='transition-transform ease-linear'
              style={{opacity: textOpacity[0]}}
            >
              집 안에 머무는 단절된 생활보다 밖으로 나올 때<br/>
              몸과 마음이 더 건강해진다고 믿습니다.
            </motion.div>
          </div>
        </div>

        <div className="absolute inset-0 w-full h-screen flex items-center justify-center z-[2]">
          <div className="overflow-hidden">
            <motion.div
              className='transition-transform ease-linear'
              style={{y: textY[1], opacity: textOpacity[1]}}
            >
              외부 활동의 불편과 위험 때문에<br/>
              작은 외출조차 망설여지는 일이 없도록
            </motion.div>
          </div>
        </div>

        <div className="absolute inset-0 w-full h-screen flex items-center justify-center z-[2]">
          <div className="overflow-hidden">
            <motion.div
              className='transition-transform ease-linear'
              style={{y: textY[2], opacity: textOpacity[2]}}
            >
              ICT 기술로 고객의 삶을<br/>
              더 안전하고 편리하게 만들겠습니다.
            </motion.div>
          </div>
        </div>

        <div className="absolute inset-0 w-full h-screen flex items-center justify-center z-[2]">
          <div className="overflow-hidden">
            <motion.div
              className='transition-transform ease-linear'
              style={{y: textY[3], opacity: textOpacity[3]}}
            >
              모두가 보장받아야 할 이동의 자유와 안전<br/>
              그리고 편리한 생활
            </motion.div>
          </div>
        </div>

        <div className="absolute inset-0 w-full h-screen flex items-center justify-center z-[2]">
          <div className="overflow-hidden">
            <motion.div
              className='transition-transform ease-linear'
              style={{ y: textY[4] }}
            >
              모듈링크는 고객과 함께 차별 없는 사회<br/>
              건강하고 활기찬 세상을 만들어 나갈 것입니다.
            </motion.div>
          </div>
        </div>


      </div>
    </section>
  )
}